import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEMAND_HEATMAP_RAMP } from "./DemandHeatmap";
const wrapperStyle = {
    display: "inline-flex",
    flexDirection: "column",
    gap: 8,
    padding: "10px 14px",
    backgroundColor: "var(--color-pure-white)",
    border: "1px solid var(--color-pebble)",
    borderRadius: 0,
    fontFamily: "var(--font-display)",
    color: "var(--color-deep-ink)",
    userSelect: "none",
};
const captionStyle = {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    color: "var(--color-cool-ash)",
};
const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
};
const swatchStripStyle = {
    display: "inline-flex",
    height: 12,
    border: "1px solid var(--color-pebble)",
};
const swatchStyle = (color) => ({
    width: 18,
    height: 12,
    backgroundColor: color,
    display: "inline-block",
});
const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "var(--color-cool-ash)",
};
export function HeatmapLegend({ caption, style, }) {
    return (_jsxs("div", { style: { ...wrapperStyle, ...style }, "data-testid": "heatmap-legend", role: "figure", "aria-label": "Demand density ramp", children: [_jsx("div", { style: captionStyle, children: "Demand \u00B7 MCP calls" }), _jsxs("div", { style: rowStyle, children: [_jsx("span", { style: labelStyle, children: "low" }), _jsx("div", { style: swatchStripStyle, "aria-hidden": "true", children: DEMAND_HEATMAP_RAMP.map((c, i) => (_jsx("span", { style: swatchStyle(c), "data-testid": `heatmap-swatch-${i}` }, `${c}-${i}`))) }), _jsx("span", { style: labelStyle, children: "high" })] }), caption && (_jsx("div", { style: {
                    fontSize: 11,
                    color: "var(--color-cool-ash)",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    fontWeight: 700,
                }, children: caption }))] }));
}
